import createIcon from '../../createIcon';

/**
 * @component @name Living
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxMS41QzE1Ljk1IDExLjUgMTUuNSAxMS45NSAxNS41IDEyLjVWMTQuNUg4LjVWMTIuNUM4LjUgMTEuOTUgOC4wNSAxMS41IDcuNSAxMS41QzYuOTUgMTEuNSA2LjUgMTEuOTUgNi41IDEyLjVWMTZDNi41IDE2LjI4IDYuNzIgMTYuNSA3IDE2LjVIMTdDMTcuMjggMTYuNSAxNy41IDE2LjI4IDE3LjUgMTZWMTIuNUMxNy41IDExLjk1IDE3LjA1IDExLjUgMTYuNSAxMS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwIDEyLjVWMTNIMTRWMTIuNUMxNCAxMS4yIDE0Ljk5IDEwLjE1IDE2LjI1IDEwLjAzVjlDMTYuMjUgOC4xNyAxNS41OCA3LjUgMTQuNzUgNy41SDkuMjVDOC40MiA3LjUgNy43NSA4LjE3IDcuNzUgOVYxMC4wM0M5LjAxIDEwLjE1IDEwIDExLjIgMTAgMTIuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAySDRDMi45IDIgMiAyLjkgMiA0VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE5IDE2QzE5IDE3LjEgMTguMSAxOCAxNyAxOEg3QzUuOSAxOCA1IDE3LjEgNSAxNlYxMi41QzUgMTEuNTggNS41MSAxMC43OCA2LjI1IDEwLjM1VjlDNi4yNSA3LjM0IDcuNTkgNiA5LjI1IDZIMTQuNzVDMTYuNDEgNiAxNy43NSA3LjM0IDE3Ljc1IDlWMTAuMzVDMTguNDkgMTAuNzggMTkgMTEuNTggMTkgMTIuNVYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Living = createIcon('Living', [
  [
    'path',
    {
      d: 'M16.5 11.5C15.95 11.5 15.5 11.95 15.5 12.5V14.5H8.5V12.5C8.5 11.95 8.05 11.5 7.5 11.5C6.95 11.5 6.5 11.95 6.5 12.5V16C6.5 16.28 6.72 16.5 7 16.5H17C17.28 16.5 17.5 16.28 17.5 16V12.5C17.5 11.95 17.05 11.5 16.5 11.5Z',
      key: 'vl8ano',
    },
  ],
  [
    'path',
    {
      d: 'M10 12.5V13H14V12.5C14 11.2 14.99 10.15 16.25 10.03V9C16.25 8.17 15.58 7.5 14.75 7.5H9.25C8.42 7.5 7.75 8.17 7.75 9V10.03C9.01 10.15 10 11.2 10 12.5Z',
      key: '145cxi',
    },
  ],
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM19 16C19 17.1 18.1 18 17 18H7C5.9 18 5 17.1 5 16V12.5C5 11.58 5.51 10.78 6.25 10.35V9C6.25 7.34 7.59 6 9.25 6H14.75C16.41 6 17.75 7.34 17.75 9V10.35C18.49 10.78 19 11.58 19 12.5V16Z',
      key: '1mn1ln',
    },
  ],
]);

export default Living;
